import { RouteEnum } from '@/layouts/routes/model/Route.model.ts';

export const PATHS_NOT_REQUIRING_AUTHORIZATION = [
  RouteEnum.LOGIN_ELIVION,
  RouteEnum.NOT_AUTHORIZED,
  RouteEnum.FORBIDDEN,
];

export const PATHS_WITHOUT_SESSION = PATHS_NOT_REQUIRING_AUTHORIZATION.map(path =>
  path.toString(),
).includes(location.pathname);
